export const sharedData = {
  statusObject: {
    atendida: 'Atendida',
    ocupado: 'Ocupado',
    acessoNegado: 'Acesso Negado',
    naoAtendida: 'Não Atendida',
    error: 'Erro',
    outros: 'Outros',
    pending: 'Pendente',
  },
  titleObject: {
    atendida: 'Status Atendimento: Atendida',
    ocupado: 'Status Atendimento: Ocupado',
    acessoNegado: 'Status Atendimento: Acesso Negado',
    naoAtendida: 'Status Atendimento: Não Atendida',
    error: 'Status Atendimento: Erro',
    outros: 'Status Atendimento: Outros',
    pending: 'Status Atendimento: Pendente',
  },
  actionObject: {
    DiscarGrupo: 'Discar para grupo de atendimento',
    DiscarRamal: 'Discar para ramal',
    DiscarTronco: 'Discar para tronco',
    TocarUra: 'Discar para URA',
    TocarSinalDeOcupado: 'Tocar sinal de ocupado',
    TocarAudio: 'Tocar áudio',
    ValidarSenha: 'Validar senha',
    ChangeToTrueActiveRegex: 'Ativar expressão regular',
    ChangeToFalseActiveRegex: 'Desativar expressão regular',
    DiscarFila: 'Discar para fila',
    DiscarAgente: 'Discar para operador',
    DiscarConferencia: 'Discar para conferência',
  },
}
